<template>
	<div>
		<div class="container">
			<el-tabs v-model="tabactiveName" @tab-click="tabhandleClick">
				<el-tab-pane label="坐席状态" name="trumpetspecialServiceNumber">
					<div class="handle-box">
						<el-select size="small" v-if="isAdmin" @change="agentChange" v-model="query.agentId" filterable
							clearable placeholder="代理商" class="handle-select mr10" style="width: 260px">
							<el-option v-for="item in agents" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-select size="small" v-if="isNormal || isAgent" v-model="query.companyId"
							@change="companyChange" filterable clearable placeholder="企业" class="handle-select mr10"
							style="width: 260px">
							<el-option v-for="item in companys" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-select size="small" v-model="query.cardsId" filterable clearable placeholder="请选择品牌"
							class="handle-select mr10" style="width: 140px">
							<el-option v-for="item in serverLists" :key="item.cardsId" :label="item.cardType"
								:value="item.cardsId"></el-option>
						</el-select>
						<el-select size="small" v-if="isNormal || isAgent" v-model="query.packageMinutes"
							@change="packageChange" filterable clearable placeholder="号码套餐信息" class="handle-select mr10"
							style="width: 240px">
							<el-option v-for="item in packageList" :key="item" :label="item+'分钟'"
								:value="item"></el-option>
						</el-select>
						<el-input size="small" v-model="query.phone" clearable placeholder="请输入坐席号码"
							class="handle-input mr10" style="width: 180px"></el-input>
						<el-input size="small" v-model="query.tely" clearable placeholder="请输入Y号码"
							class="handle-input mr10" style="width: 180px"></el-input>
						<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
							@click="handleSearch">搜索</el-button>
					</div>
					<el-tabs v-model="activeName" type="card" @tab-click="handleClick"
						:class="'custom-tabs-' + activeName">
						<el-tab-pane :label="'全部'+'  '+'('+allVul+')'" name="all"></el-tab-pane>
						<el-tab-pane :label="'正常'+'  '+'('+susVul+')'" name="sus"></el-tab-pane>
						<el-tab-pane :label="'未购买套餐'+'  '+'('+noPackageVul+')'" name="noPackage"></el-tab-pane>
						<el-tab-pane :label="'已停用'+'  '+'('+stopVul+')'" name="stop"
							style="position: relative;"></el-tab-pane>
					</el-tabs>
					<el-table :data="tableData" border class="table" ref="multipleTable" max-height="600"
						header-cell-class-name="table-header" @selection-change="handleSelectionChange"
						:header-cell-style="{ 'text-align': 'center' }" :row-style="{ height: '20px' }"
						:cell-style="{ padding: '6px' }" stripe v-loading="loading">
						<el-table-column prop="agentName" label="代理" align="center" v-if="isAdmin&&!query.agentId"
							min-width="180"></el-table-column>
						<el-table-column prop="companyName" label="企业" align="center"
							v-if="(isAdmin||isAgent)&&!query.companyId" min-width="180"></el-table-column>
						<el-table-column prop="userPhone" label="坐席号码" align="center" width="115"></el-table-column>
						<el-table-column prop="accounts" label="外呼号码" align="center" width="240">
							<template #default="scope">
								<div v-for="item in scope.row.accounts" :key="item.phone" @click="tabBind(scope.row)">
									<el-tag style="margin-bottom: 6px;cursor: pointer;" v-if="item.isUse" size="small">
										<span>启用</span>
										{{item.phone}}&nbsp;&nbsp;{{item.province}}
										{{item.city}}&nbsp;&nbsp;{{item.standard}}</el-tag>
									<el-tag style="margin-bottom: 6px;cursor: pointer;" class="red" v-else size="small">
										<span>禁用</span>
										{{item.phone}}&nbsp;&nbsp;{{item.province}}
										{{item.city}}&nbsp;&nbsp;{{item.standard}}</el-tag>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="cardName" label="品牌" align="center" width="100"></el-table-column>
						<el-table-column prop="totalMinutes" label="总时长" align="center" width="90">
							<template #default="scope">
								<span>{{scope.row.totalMinutes||0}}分钟</span>
							</template>
						</el-table-column>
						<el-table-column prop="useMinutes" label="使用时长" align="center" width="90">
							<template #default="scope">
								<span>{{scope.row.useMinutes||0}}分钟</span>
							</template>
						</el-table-column>
						<el-table-column label="剩余时长" align="center" width="90">
							<template #default="scope">
								<span>{{scope.row.totalMinutes-scope.row.useMinutes||0}}分钟</span>
							</template>
						</el-table-column>
						<el-table-column prop="packageName" label="普通包" align="center" width="150">
							<template #default="scope">
								<el-tag size="small" v-if="scope.row.packageName">{{scope.row.packageName}}</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="outside" label="加量包" align="center" width="140">
							<template #default="scope">
								<el-tag v-for="item in scope.row.outside" :key="item" size="small"
									style="display: flex;flex-direction: column;margin:6px 0;">{{item}}</el-tag>
							</template>
						</el-table-column>

						<el-table-column prop="expirationTime" label="过期时间" align="center"
							width="160"></el-table-column>

						<el-table-column label="操作" width="240" align="center" fixed="right">
							<template #default="scope">
								<el-button size="small" type="text" v-if="isAdmin"
									@click="plan(scope.row)">划拨套餐</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="pagination">
						<el-pagination background layout="total, sizes, prev, pager, next, jumper"
							:current-page="query.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
							:page-size="query.pageSize" :total="pageTotal" @size-change="handleSizeChange"
							@current-change="handlePageChange"></el-pagination>
					</div>
					<el-dialog title="分配套餐" v-model="planVisible" width="550px" @close="closeDialog">
						<el-form label-width="120px" :model="planForm" ref="planForm">
							<el-form-item prop="packageName" label="行业">
								<el-radio-group v-model="planForm.type">
									<el-radio v-for="item in typeList" :key="item.value" :label="item.value"
										:value="item.value" style="margin: 12px 6px;">{{item.label}}</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item label="普通包" v-if="planForm.type=='content'">
								<el-radio-group v-model="planForm.minutes">
									<el-radio v-for="item in contentList" :key="item.value" :label="item.minutes"
										:value="item.minutes"
										style="margin: 12px 6px;">{{item.price + '元'+ item.minutes + '分钟'}}</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item label="加量包" v-if="planForm.type=='outside'">
								<el-radio-group v-model="planForm.minutes">
									<el-radio v-for="item in outsideList" :key="item.value" :label="item.minutes"
										:value="item.minutes"
										style="margin: 12px 6px;">{{item.price + '元'+ item.minutes + '分钟'}}</el-radio>

								</el-radio-group>
							</el-form-item>
							<el-form-item class="dis-end">
								<el-button size="small" @click="closeDialog">取消</el-button>
								<el-button size="small" type="primary" :class="[theme]"
									@click="getTransferSipSetMeal">确定</el-button>
							</el-form-item>
						</el-form>
					</el-dialog>
					<el-dialog title="实名信息" v-model="upFaceInfoVisible" width="450px" @close="closeDialog2">
						<el-form label-width="120px" :model="upFaceInfoForm" ref="upFaceInfoForm">
							<el-form-item prop="name" label="姓名">
								<el-input size="small" v-model="upFaceInfoForm.name" clearable
									placeholder="请输入姓名"></el-input>
							</el-form-item>
							<el-form-item prop="idNo" label="身份证号">
								<el-input size="small" v-model="upFaceInfoForm.idNo" clearable
									placeholder="请输入身份证号"></el-input>
							</el-form-item>
							<el-form-item class="dis-end">
								<el-button size="small" @click="closeDialog2">取消</el-button>
								<el-button size="small" type="primary" :class="[theme]"
									@click="getUploadFace">确定</el-button>
							</el-form-item>
						</el-form>
					</el-dialog>
					<el-dialog v-model="imgVisible" title="实名信息" width="450px">
						<el-form label-width="120px" :model="infoForm" ref="infoForm">
							<el-form-item prop="name" label="姓名">
								<el-input size="small" v-model="infoForm.name" clearable placeholder="请输入姓名"
									disabled></el-input>
							</el-form-item>
							<el-form-item prop="idNo" label="身份证号">
								<el-input size="small" v-model="infoForm.idNo" clearable placeholder="请输入身份证号"
									disabled></el-input>
							</el-form-item>
						</el-form>
					</el-dialog>
					<el-dialog v-model="deleteVisible" width="450px" @close="closeDialog3">
						<el-form label-width="120px" :model="deleteForm" ref="deleteForm">
							<el-form-item prop="packageName" label="原因">
								<el-input type="textarea" v-model="deleteForm.remark" placeholder="请输入操作的原因"></el-input>
							</el-form-item>
							<el-form-item class="dis-end">
								<el-button size="small" @click="closeDialog3">取消</el-button>
								<el-button size="small" type="primary" :class="[theme]"
									@click="getDelete">确定</el-button>
							</el-form-item>
						</el-form>
					</el-dialog>
					<el-dialog v-model="ModifyFaceStateVisible" width="450px" @close="closeDialog3">
						<el-form label-width="120px" :model="ModifyFaceStateForm" ref="ModifyFaceStateForm">
							<el-form-item prop="packageName" label="原因">
								<el-input type="textarea" v-model="ModifyFaceStateForm.remark"
									placeholder="请输入修改人脸识别的原因"></el-input>
							</el-form-item>
							<el-form-item class="dis-end">
								<el-button size="small" @click="closeDialog3">取消</el-button>
								<el-button size="small" type="primary" :class="[theme]"
									@click="getModifyFaceState">确定</el-button>
							</el-form-item>
						</el-form>
					</el-dialog>
					<el-dialog v-model="faceRecordVisible" width="850px" @close="closeDialog3">
						<el-select size="small" @change="faceRecords" v-model="faceRecordType" filterable clearable
							placeholder="类型" style="width: 180px;margin-bottom: 20px;">
							<el-option v-for="item in faceRecordList" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-table :data="faceRecordData" border class="table" ref="multipleTable"
							header-cell-class-name="table-header" :header-cell-style="{ 'text-align': 'center' }"
							:row-style="{ height: '20px' }" :cell-style="{ padding: '6px' }" stripe v-loading="loading">
							<el-table-column prop="userPhone" label="账号" align="center" width="115"></el-table-column>
							<el-table-column prop="type" label="类型" align="center" width="140"></el-table-column>
							<el-table-column prop="remark" label="备注" align="center"></el-table-column>
							<el-table-column prop="createdAt" label="时间" align="center" width="160"></el-table-column>
						</el-table>
					</el-dialog>

					<el-dialog title="绑定" v-model="bindVisible" width="850px" @close="closeDialog4">
						<el-form label-width="120px" :model="bindForm" ref="bindForm">
							<el-form-item prop="packageName" label="号码">
								<el-radio-group v-model="bindForm.phone">
									<el-radio v-for="item in accountsList" :key="item.phone" :label="item.phone"
										:value="item.phone" style="margin: 12px 6px;">{{item.phone}}</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item class="dis-end">
								<el-button size="small" @click="closeDialog4">取消</el-button>
								<el-button size="small" type="primary" :class="[theme]"
									@click="getsettingsSipAccount">确定</el-button>
							</el-form-item>
						</el-form>
					</el-dialog>

				</el-tab-pane>
				<el-tab-pane label="号码列表" name="sipNumber">
					<div class="handle-box">
						<el-select size="small" v-if="isAdmin" @change="agentChange" v-model="query2.agentId" filterable
							clearable placeholder="代理商" class="handle-select mr10" style="width: 260px">
							<el-option v-for="item in agents" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-select size="small" v-if="isNormal || isAgent" v-model="query2.companyId"
							@change="companyChange" filterable clearable placeholder="企业" class="handle-select mr10"
							style="width: 260px">
							<el-option v-for="item in companys" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-select size="small" v-model="query2.isUse" filterable clearable placeholder="是否开通"
							class="handle-select mr10" style="width: 140px">
							<el-option v-for="item in isUseList" :key="item.label" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-button size="mini" type="primary" :class="[theme]" icon="el-icon-search"
							@click="getsipNumberData">搜索</el-button>
					</div>

					<el-table :data="sipNumbertableData" border class="table" ref="multipleTable"
						header-cell-class-name="table-header" @selection-change="handleSelectionChange"
						:header-cell-style="{ 'text-align': 'center' }" :row-style="{ height: '20px' }"
						:cell-style="{ padding: '6px' }" stripe v-loading="loading">
						<el-table-column prop="agentName" label="代理" align="center" width="180"
							v-if="isAdmin"></el-table-column>
						<el-table-column prop="companyName" label="企业" align="center" width="180"
							v-if="isAdmin||isAgent"></el-table-column>
						<el-table-column prop="phone" label="Y号码" align="center" width="130"></el-table-column>
						<el-table-column prop="standard" label="Y号码制式" align="center" width="130"></el-table-column>
						<el-table-column label="归属地" align="center" width="130">
							<template #default="scope">
								<span>{{scope.row.province}}-{{scope.row.city}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="cardName" label="品牌" align="center" width="130"></el-table-column>
						<el-table-column prop="isUse" label="绑定坐席" align="center" width="130">
							<template #default="scope">
								<span v-if="scope.row.isUse==true">{{scope.row.steMealInfo}}</span>
								<span v-if="scope.row.isUse==false" class="red">未绑定</span>
							</template>
						</el-table-column>
						<el-table-column prop="buy" label="是否开通" align="center" width="110">
							<template #default="scope">
								<span v-if="scope.row.buy==true" class="red">未开通</span>
								<span v-if="scope.row.buy==false" style="color: #54b663;">已开通</span>
							</template>
						</el-table-column>

						<el-table-column prop="expirationTime" label="过期时间" align="center"
							width="160"></el-table-column>
						<el-table-column prop="isSelect" label="外呼号码" align="center">
							<template #default="scope">
								<span v-if="scope.row.isSelect==true" style="color: #54b663;">是</span>
								<span v-if="scope.row.isSelect==false" class="red">否</span>
							</template>
						</el-table-column>
						<el-table-column prop="createdAt" label="创建时间" align="center" width="160"></el-table-column>
						<el-table-column label="操作" align="center" width="240" fixed="right">
							<template #default="scope">
								<el-button size="mini" type="text" @click="getbindVisible(scope.row.id)"
									v-if="scope.row.isUse==false">绑定</el-button>
								<el-button size="mini" type="text"
									@click="getSipAccountOccupy(scope.row)">购买</el-button>
								<el-button size="mini" type="text" @click="setAddVisible(scope.row)"
									v-if="scope.row.log?.length">查看记录</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="pagination">
						<el-pagination background layout="total, sizes, prev, pager, next, jumper"
							:current-page="query2.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
							:page-size="query2.pageSize" :total="sipNumberpageTotal" @size-change="handleSizeChange2"
							@current-change="handlePageChange2"></el-pagination>
					</div>
					<el-dialog title="购买记录" v-model="logVisible" width="750px" @close="closeDialog('multipleTable')">
						<el-table :data="sipNumbertableData2" border class="table" ref="multipleTable"
							header-cell-class-name="table-header" :header-cell-style="{ 'text-align': 'center' }"
							:row-style="{ height: '20px' }" :cell-style="{ padding: '6px' }" stripe v-loading="loading">
							<el-table-column prop="opUser" label="操作人" align="center" width="120"></el-table-column>
							<el-table-column prop="type" label="操作类型" align="center" width="110"></el-table-column>
							<el-table-column prop="value" label="备注" align="center"></el-table-column>
							<el-table-column prop="opTime" label="记录时间" align="center" width="160"></el-table-column>
						</el-table>
					</el-dialog>
					<el-dialog title="支付" v-model="payVisible" width="450px" @close="closeDialog('payForm')">
						<el-form :model="payForm" :rules="payForm" ref="payForm" label-width="100px">
							<el-form-item prop="type" label="充值类型">
								<el-radio-group v-model="payForm.type" @change="typeChange">
									<el-radio label="wxpay" value="wxpay">微信</el-radio>
									<el-radio label="alipay" value="alipay">支付宝</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item label="扫码支付" v-show="payUrl">
								<div id="qrcode" ref="qrcode" style="position: relative;"></div>
								<div>
									<img src="../assets/img/wxpay.png" v-if="wxpayUrl" alt=""
										style="position: absolute;top: 46px;left:44px;width: 42px;height: 42px;" />
								</div>
								<div>
									<img src="../assets/img/alipay.png" v-if="alipayUrl" alt=""
										style="position: absolute;top: 46px;left:44px;width: 42px;height: 42px;" />
								</div>
							</el-form-item>
							<el-form-item class="dis-end">
								<el-button size="small" type="primary" :class="[theme]"
									@click="addRecordLabel('form')">生成二维码</el-button>
							</el-form-item>
						</el-form>
					</el-dialog>
					<el-dialog title="绑定" v-model="bindVisible" width="450px" @close="closeDialog5">
						<el-form :model="bindForm" :rules="bindForm" ref="bindForm" label-width="100px">
							<el-form-item prop="type" label="绑定类型">
								<el-radio-group v-model="bindForm.type">
									<el-radio label="bind" value="bind">绑定</el-radio>
									<el-radio label="unbind" value="unbind">解绑</el-radio>
								</el-radio-group>
							</el-form-item>
							<div v-if="bindForm.type=='bind'">
								<el-form-item prop="phone" label="号码" v-if="phoneList.length">
									<el-radio-group v-model="bindForm.phone">
										<el-radio v-for="item in phoneList" :key="item.phone" :label="item.phone"
											:value="item.phone" style="margin-bottom: 6px;">{{ item.phone }} 已绑定
											{{item.accountCount}} 次</el-radio>
									</el-radio-group>
								</el-form-item>
							</div>
							<el-form-item class="dis-end">
								<el-button size="small" @click="closeDialog5">取消</el-button>
								<el-button size="small" type="primary" :class="[theme]"
									@click="getbindSetMealAccount">确认</el-button>
							</el-form-item>
						</el-form>
					</el-dialog>
					<el-dialog title="实名认证" v-model="accountEnterVisible" width="450px"
						@close="closeAccountEnterDialog">
						<el-form :model="accountEnterForm" ref="accountEnterForm" label-width="100px">
							<el-form-item prop="name" label="姓名">
								<el-input size="small" v-model="accountEnterForm.name" clearable
									placeholder="请输入姓名"></el-input>
							</el-form-item>
							<el-form-item prop="idNo" label="身份证号">
								<el-input size="small" v-model="accountEnterForm.idNo" clearable
									placeholder="请输入身份证号码"></el-input>
							</el-form-item>
							<el-form-item prop="telx" label="X号码">
								<el-input size="small" v-model="accountEnterForm.telx" clearable
									placeholder="请输入X号码"></el-input>
							</el-form-item>
							<el-form-item prop="telxStandard" label="制式">
								<el-select size="small" v-model="accountEnterForm.telxStandard" filterable clearable
									placeholder="请选择制式" style="width: 100%;">
									<el-option v-for="item in standardList" :key="item.label" :label="item.label"
										:value="item.value"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item class="dis-end">
								<el-button size="small" @click="closeAccountEnterDialog">取消</el-button>
								<el-button size="small" type="primary" :class="[theme]"
									@click="getsipAccountEnter">确定</el-button>
							</el-form-item>
						</el-form>
					</el-dialog>
				</el-tab-pane>
				<el-tab-pane label="号码价格" name="sipAccountPrice" v-if='isAdmin|| isAgent'>
					<div class="handle-box">
						<el-select size="small" v-if="isAdmin" @change="agentChange" v-model="query3.agentId" filterable
							clearable placeholder="代理商" class="handle-select mr10" style="width: 260px">
							<el-option v-for="item in agents" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-select size="small" v-model="query3.cardsId" filterable clearable placeholder="请选择号码品牌"
							class="handle-select mr10" style="width:180px">
							<el-option v-for="item in serverLists" :key="item.cardsId" :label="item.cardType"
								:value="item.cardsId"></el-option>
						</el-select>
						<el-button size="mini" type="primary" :class="[theme]" icon="el-icon-search"
							@click="getsipAccountPriceData()">搜索</el-button>
						<el-button size="mini" type="primary" :class="[theme]" @click="getsetPriceVisible"
							v-if="isAdmin">设置</el-button>
					</div>

					<el-table :data="sipAccountPricetableData" border class="table" ref="multipleTable"
						header-cell-class-name="table-header" @selection-change="handleSelectionChange"
						:header-cell-style="{ 'text-align': 'center' }" :row-style="{ height: '20px' }"
						:cell-style="{ padding: '6px' }" stripe v-loading="loading">
						<el-table-column prop="agentName" label="代理" align="center"></el-table-column>
						<el-table-column prop="cardName" label="品牌" align="center"></el-table-column>
						<el-table-column prop="price" label="价格(元)" align="center"></el-table-column>
						<el-table-column label="操作" align="center" width="240" v-if="isAdmin">
							<template #default="scope">
								<el-button size="small" type="primary" :class="[theme]"
									@click="showEdit(scope.row)">编辑</el-button>
							</template>
						</el-table-column>
					</el-table>
					<el-dialog title="设置价格" v-model="setPriceVisible" width="450px"
						@close="closeDialog('setPriceForm')">
						<el-form :model="setPriceForm" ref="setPriceForm" label-width="100px">
							<el-form-item prop="agentId" label="代理商">
								<el-select size="small" v-model="setPriceForm.agentId" filterable clearable
									placeholder="请选择代理商" style="width: 100%;">
									<el-option v-for="item in agents" :key="item.value" :label="item.label"
										:value="item.value"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item prop="cardsId" label="品牌">
								<el-select size="small" v-model="setPriceForm.cardsId" filterable clearable
									placeholder="请选择品牌" style="width: 100%;">
									<el-option v-for="item in serverLists" :key="item.cardsId" :label="item.cardType"
										:value="item.cardsId"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item prop="accountPrice" label="价格">
								<el-input size="small" v-model="setPriceForm.accountPrice" clearable
									placeholder="请输入价格"></el-input>
							</el-form-item>
							<el-form-item class="dis-end">
								<el-button size="small" @click="setPriceVisible=false">取消</el-button>
								<el-button size="small" type="primary" :class="[theme]"
									@click="getsetSipAccountPrice">确定</el-button>
							</el-form-item>
						</el-form>
					</el-dialog>

					<el-dialog title="设置价格" v-model="editVisible" width="450px" @close="closeEditDialog">
						<el-form :model="editForm" ref="editForm" label-width="100px">
							<el-form-item prop="agentName" label="代理商">
								<el-input size="small" v-model="editForm.agentName" disabled></el-input>
							</el-form-item>
							<el-form-item prop="cardName" label="品牌">
								<el-input size="small" v-model="editForm.cardName" disabled></el-input>
							</el-form-item>
							<el-form-item prop="price" label="价格">
								<el-input size="small" v-model="editForm.price" clearable
									placeholder="请输入价格"></el-input>
							</el-form-item>
							<el-form-item class="dis-end">
								<el-button size="small" @click="editVisible = false">取消</el-button>
								<el-button size="small" type="primary" :class="[theme]"
									@click="getsipAccountPriceUpdate">确定</el-button>
							</el-form-item>
						</el-form>
					</el-dialog>
				</el-tab-pane>
			</el-tabs>

		</div>
	</div>
</template>

<script>
	import {
		fetchDepartment
	} from '../api/index.js';
	import {
		fetchAgent
	} from '../api/agentIndex.js';
	import {
		fetchCompanyByAgentId,
		fetchDefaultCompanies
	} from '../api/companyIndex';
	import {
		accountJobSetMeal,
		accountJobAssignable,
		transferJobSipSetMeal,
		uploadFace,
		clearFaceInfo,
		ModifyFaceState,
		queryJobPackageList,
		serverList,
		FaceRecord,
		settingsSipAccount,

		sipAccountPriceQuery,
		setSipAccountPrice,
		sipAccountPriceUpdate,

		sipAccountList,
		sipAccountOccupy,
		sipAccountOccupyOrder,
		sipAccountOrderQuery,
		bindQuery,
		bindSetMealAccount,
		sipAccountEnter
	} from '../api/cdrBatch.js';
	import QRCode from 'qrcodejs2';
	export default {
		name: 'cdrBatchType',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				tabactiveName: "trumpetspecialServiceNumber",
				query: {
					companyId: '',
					agentId: '',
					phone: '',
					tely: '',
					packageMinutes: '',
					cardsId: '',
					type: 'all',
					pageIndex: 1,
					pageSize: 10,
				},
				query2: {
					companyId: '',
					agentId: '',
					isUse: null,
					pageIndex: 1,
					pageSize: 10,
				},
				query3: {
					agentId: '',
					cardsId: '',
				},
				contentList: [],
				outsideList: [],
				serverLists: [], //SIPServer服务器的列表
				activeName: 'all',
				allVul: 0,
				susVul: 0,
				noPackageVul: 0,

				stopVul: 0,
				agents: [],
				companys: [],
				tableData: [],
				sipNumbertableData: [],
				sipNumbertableData2: [],
				sipAccountPricetableData: [],
				isAdmin: false,
				isAgent: false,
				isNormal: false,
				pageTotal: 0,
				sipNumberpageTotal: 0,

				role: '',
				planVisible: false,
				planForm: {
					type: 'content'
				},
				typeList: [{
					value: 'content',
					label: '普通包',
				}, {
					value: 'outside',
					label: '加量包',
				}],
				faceRecordList: [{
					value: '1',
					label: '录入人脸',
				}, {
					value: '2',
					label: '删除人脸',
				}, {

					value: '3',
					label: '活体检测',
				}, {

					value: '4',
					label: '修改人脸',
				}],
				upFaceInfoVisible: false,
				hideUpload: false,
				limitCount: 1,
				fileList: [],
				uploadData: {
					userId: '',
					currentUserId: '',
					file: ''
				},
				dialogImageUrl: null,
				uploadImgBig: false,
				imgVisible: false,
				srcimgurl: '',
				progress: 0,
				deleteForm: {
					remark: '',
					id: ''
				},
				deleteVisible: false,
				ModifyFaceStateForm: {
					remark: '',
					id: ''
				},
				ModifyFaceStateVisible: false,
				packageList: [],
				rowId: '',
				faceRecordData: [],
				faceRecordVisible: false,
				faceRecordType: '',

				accountsList: [],
				upFaceInfoForm: {
					name: '',
					idNo: '',
					userId: '',
					currentUserId: '',
				},
				infoForm: {
					name: '',
					idNo: '',
				},

				/* sipAccountPrice里面的参数 */
				isUseList: [{
					value: true,
					label: '已开通',
				}, {
					value: false,
					label: '未开通',
				}],
				setPriceVisible: false,
				setPriceForm: {
					agentId: '',
					accountPrice: '',
					cardsId: '',
				},
				editVisible: false,
				editForm: {
					price: '',
					cardName: '',
					agentName: '',
					id: ''
				},

				/* sipNumber里面的参数 */
				standardList: [{
					value: '移动',
					label: '移动',
				}, {
					value: '联通',
					label: '联通',
				}, {
					value: '电信',
					label: '电信',
				}],

				logVisible: false,
				tableData2: [],
				payForm: {
					type: 'wxpay',
				},
				payVisible: false,
				payUrl: false,
				wxpayUrl: false,
				alipayUrl: false,
				clearInterval: null,

				bindVisible: false,
				bindForm: {
					type: 'bind',
					phone: '',
					ids: '',
					userId: localStorage.getItem('user'),
				},
				phoneList: [],
				accountEnterVisible: false,
				accountEnterForm: {
					id: '',
					name: '',
					idNo: '',
					telx: '',
					telxStandard: '',
				}
			};
		},
		created() {
			this.role = localStorage.getItem('ms_role');
			this.init();
			if (this.role === 'admin') {
				this.isAdmin = true;
				this.isNormal = true;
			}
			if (this.role == 'agent') {
				this.isAgent = true;
				this.isNormal = true;
			}
			this.getqueryPackageList();
			this.getServerList();
			this.updateTabStyle();
			this.updatePaginationStyle();
		},
		methods: {
			updatePaginationStyle() {
				let pagination = document.getElementById('pagination');
				if (!pagination) {
					pagination = document.createElement('style');
					pagination.id = 'dynamic-tab-style';
					document.head.appendChild(pagination);
				}
				pagination.innerHTML = `
				    .active {
				        background-color: ${this.theme8} !important;
						color: #fff !important;
				    }
					.number:hover {
				        color: ${this.theme8} !important;
				    }
					.active:hover {
					    color: #fff !important;
					}
					.more:hover {
					    color: ${this.theme8} !important;
					}
				`;
			},
			updateTabStyle() {
				// 动态更新样式
				let styleEl = document.getElementById('dynamic-tab-style');
				if (!styleEl) {
					styleEl = document.createElement('style');
					styleEl.id = 'dynamic-tab-style';
					document.head.appendChild(styleEl);
				}

				styleEl.innerHTML = `
			        .el-tabs__active-bar {
			            background-color: ${this.theme8} !important;
			        }
			        .el-tabs__item.is-active {
			            color: ${this.theme8} !important;
			        }
			        .el-tabs__item:hover {
			            color: ${this.theme8} !important;
			            opacity: 0.8;
			        }
			    `;
			},
			//sip服务器列表
			getServerList() {
				let data = {
					pageIndex: 1,
					pageSize: 100,
				}
				serverList(data).then(res => {
					if (res?.code === 200) {
						this.serverLists = res.data.list;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getfetchDefaultCompanies() {
				this.query.companyId = '';
				let data = {
					currentUserId: localStorage.getItem('user'),
					subAgentId: this.query.subAgentId
				};
				fetchDefaultCompanies(data).then(res => {
					this.companys = res.data;
					if (this.role == 'agent') {
						// this.query.companyId = res.data[0].value;
						this.getTrumpetspecialServiceNumberData();
					}
				});
			},


			init() {
				fetchAgent(localStorage.getItem('user')).then(res => {
					this.agents = res.data;
				});
				this.getfetchDefaultCompanies();
			},
			getTrumpetspecialServiceNumberData() {
				let data = {
					userId: localStorage.getItem('user'),
					agentId: this.query.agentId,
					companyId: this.query.companyId,
					phone: this.query.phone,
					tely: this.query.tely,
					cardsId: this.query.cardsId,
					type: this.query.type,
					packageMinutes: this.query.packageMinutes,
					pageIndex: this.query.pageIndex,
					pageSize: this.query.pageSize,
				};
				this.loading = true;
				accountJobSetMeal(data).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.stopVul = res.customData.stop;
						this.noPackageVul = res.customData.noPackage;
						this.susVul = res.customData.sus;
						this.allVul = res.customData.all;
						this.tableData = res.data.list;
						this.pageTotal = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			agentChange(agentId) {
				this.query.agentId = agentId;
				this.query.companyId = '';
				this.query.departmentId = '';
				this.query.userId = '';
				this.query.packageMinutes = '';
				this.packageList = [];
				if (agentId) {
					let data = {
						subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
						agentId: agentId
					};
					fetchCompanyByAgentId(data).then(res => {
						this.companys = res.data;
						this.getqueryPackageList()
					});
				} else {
					this.departments = [];
					this.getqueryPackageList()
				}
			},
			companyChange(companyId) {
				this.query.companyId = companyId;
				this.query.departmentId = '';
				this.query.userId = '';
				this.query.packageMinutes = '';
				this.packageList = [];
				let data = {
					companyId: companyId,
					currentUserId: localStorage.getItem('user')
				};
				fetchDepartment(data).then(res => {
					this.departments = res.data;
					this.query.pageIndex = 1;
					this.getqueryPackageList();
				});
			},
			packageChange(packageMinutes) {
				this.query.packageMinutes = packageMinutes;
				this.getTrumpetspecialServiceNumberData()
			},
			getqueryPackageList() {
				let data = {
					agentId: this.query.agentId,
					companyId: this.query.companyId,
					userId: localStorage.getItem('user')
				};
				queryJobPackageList(data).then(res => {
					this.packageList = res.data;
					this.query.pageIndex = 1;
					this.getTrumpetspecialServiceNumberData();
				});
			},
			handleClick(tab, event) {
				this.query.type = tab.props.name;
				this.getTrumpetspecialServiceNumberData();
			},
			tabhandleClick(tab, event) {
				if (tab.props.name == 'trumpetspecialServiceNumber') {
					this.getTrumpetspecialServiceNumberData()
				} else if (tab.props.name == 'sipNumber') {
					this.getsipNumberData()
				} else if (tab.props.name == 'sipAccountPrice') {
					this.getsipAccountPriceData();
				}
			},
			// 触发搜索按钮
			handleSearch() {
				this.query.pageIndex = 1;
				this.getTrumpetspecialServiceNumberData();
			},
			// 分页导航
			handlePageChange(val) {
				this.query.pageIndex = val;
				this.getTrumpetspecialServiceNumberData();
			},
			handleSizeChange(val) {
				this.query.pageSize = val;
				this.query.pageIndex = 1; // 重置到第一页
				this.getTrumpetspecialServiceNumberData();
			},
			//人脸记录
			getFaceRecord(row) {
				this.rowId = row.id;
				this.faceRecordVisible = true;
				this.faceRecords()

			},
			faceRecords() {
				this.packageList = [];
				let data = {
					id: this.rowId,
					type: this.faceRecordType,
				};
				FaceRecord(data).then(res => {
					this.faceRecordData = res.data.list;
				});
			},
			// faceRecordData
			//划分套餐
			plan(row) {
				this.rowId = row.id;
				this.planVisible = true;
				this.contentList = [];
				this.outsideList = [];
				let data = {
					currentUserId: localStorage.getItem('user'),
					userId: row.id,
				};
				accountJobAssignable(data).then(res => {
					if (res?.code === 200) {
						this.contentList = res.data.content;
						this.outsideList = res.data.outside;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getTransferSipSetMeal() {
				let data = {
					userId: this.rowId,
					currentUserId: localStorage.getItem('user'),
					type: this.planForm.type,
					minutes: this.planForm.minutes,
				};
				transferJobSipSetMeal(data).then(res => {
					if (res?.code === 200) {
						this.planVisible = false;
						this.$message.success(res.message);
						this.getTrumpetspecialServiceNumberData();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			upFaceInfo(row) {
				this.upFaceInfoVisible = true;
				this.upFaceInfoForm.userId = row.id;
				this.upFaceInfoForm.currentUserId = localStorage.getItem('user');
			},
			getUploadFace() {
				uploadFace(this.upFaceInfoForm).then(res => {
					if (res?.code === 200) {
						this.upFaceInfoVisible = false;
						this.upFaceInfoForm.name = '';
						this.upFaceInfoForm.idNo = '';
						this.getTrumpetspecialServiceNumberData();
					} else {
						this.$message.error(res.message);
					}
				});
			},

			closeDialog2() {
				// this.upFaceInfoForm = '';
				this.upFaceInfoVisible = false;
				this.upFaceInfoForm.idNo = '';
				this.upFaceInfoForm.name = '';
				// this.$refs.upload.uploadFiles = []
			},
			closeDialog() {
				this.planVisible = false;
				this.contentList = [];
				this.outsideList = [];
			},

			bigImg(row) {
				this.imgVisible = true;
				// closeDialog3
				this.infoForm = row.info;
			},
			// 删除操作
			handleDelete(index, id) {
				this.deleteForm.remark = '';
				this.deleteVisible = true;
				this.deleteForm.id = id;
			},
			getDelete() {
				let data = {
					id: this.deleteForm.id,
					userId: localStorage.getItem('user'),
					remark: this.deleteForm.remark,
				};
				clearFaceInfo(data).then(res => {
					if (res?.code === 200) {
						this.$message.success('清除成功');
						this.deleteVisible = false;
						this.getTrumpetspecialServiceNumberData();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			closeDialog3() {
				this.deleteVisible = false;
				this.ModifyFaceStateVisible = false;
				this.deleteForm.id = '';
				this.ModifyFaceStateForm.id = '';
				this.deleteForm.remark = '';
				this.ModifyFaceStateForm.remark = '';
			},
			handleModifyFaceState(index, id) {
				this.ModifyFaceStateForm.remark = '';
				this.ModifyFaceStateVisible = true;
				this.ModifyFaceStateForm.id = id;
			},
			getModifyFaceState() {
				let data = {
					id: this.ModifyFaceStateForm.id,
					userId: localStorage.getItem('user'),
					remark: this.ModifyFaceStateForm.remark,
				};
				ModifyFaceState(data).then(res => {
					if (res?.code === 200) {
						this.$message.success('修改成功');
						this.ModifyFaceStateVisible = false;
						this.getTrumpetspecialServiceNumberData();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			//绑定
			tabBind(row) {
				this.accountsList = [];
				this.bindVisible = true;
				this.bindForm.phone = '';
				this.accountsList = row.accounts;
				this.bindForm.id = row.id;
			},
			getsettingsSipAccount() {
				let data = {
					id: this.bindForm.id,
					phone: this.bindForm.phone,
				};
				settingsSipAccount(data).then(res => {
					if (res?.code === 200) {
						this.$message.success('绑定成功');
						this.bindVisible = false;
						this.getTrumpetspecialServiceNumberData();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			closeDialog4() {
				this.bindVisible = false;
				this.accountsList = [];
				this.bindForm.phone = '';
			},
			closeDialog5() {
				this.logVisible = false;
				this.payVisible = false;
				this.bindVisible = false;
				this.accountEnterVisible = false;
				clearInterval(this.clearInterval);
			},
			/* sipNumber */
			getbindSetMealAccount() {
				let data = {
					type: this.bindForm.type,
					phone: this.bindForm.phone,
					ids: this.bindForm.ids,
					userId: localStorage.getItem('user')
				};
				bindSetMealAccount(data).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.message);
						this.bindVisible = false;
						this.getsipNumberData()
					} else {
						this.$message.error(res.message);
					}
				});
			},
			// 分页导航
			handlePageChange2(val) {
				this.query2.pageIndex = val;
				this.getsipNumberData();
			},
			handleSizeChange2(val) {
				this.query2.pageSize = val;
				this.query2.pageIndex = 1; // 重置到第一页
				this.getsipNumberData();
			},
			getsipNumberData() {
				let data = {
					userId: localStorage.getItem('user'),
					agentId: this.query2.agentId,
					companyId: this.query2.companyId,
					isUse: this.query2.isUse,
					pageIndex: this.query2.pageIndex,
					pageSize: this.query2.pageSize,
				};
				sipAccountList(data).then(res => {
					if (res?.code === 200) {
						this.sipNumbertableData = res.data.list;
						this.sipNumberpageTotal = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getaccountEnterVisible(id) {
				this.accountEnterForm.id = id;
				this.accountEnterForm.name = '';
				this.accountEnterForm.idNo = '';
				this.accountEnterForm.telx = '';
				this.accountEnterForm.telxStandard = '';
				this.accountEnterVisible = true;
			},
			getsipAccountEnter() {
				let data = {
					name: this.accountEnterForm.name,
					idNo: this.accountEnterForm.idNo,
					telx: this.accountEnterForm.telx,
					id: this.accountEnterForm.id,
					telxStandard: this.accountEnterForm.telxStandard,
					userId: localStorage.getItem('user')
				};
				sipAccountEnter(data).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.message);
						this.accountEnterVisible = false;
						this.getsipNumberData()
					} else {
						this.$message.error(res.message);
					}
				});
			},
			closeAccountEnterDialog(formName) {
				this.logVisible = false;
				this.payVisible = false;
				this.bindVisible = false;
				this.accountEnterVisible = false;
				clearInterval(this.clearInterval);
			},
			getbindVisible(id) {
				this.bindVisible = true;
				this.bindForm.ids = id;
				let data = {
					companyId: this.query2.companyId,
					userId: localStorage.getItem('user')
				};
				bindQuery(data).then(res => {
					if (res?.code === 200) {
						this.phoneList = res.data;
						this.getsipNumberData()
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getSipAccountOccupy(row) {
				this.payForm.id = row.id;
				this.payForm.type = 'wxpay';
				let data = {
					ids: this.payForm.id,
					userId: localStorage.getItem('user')
				};
				sipAccountOccupy(data).then(res => {
					if (res?.code === 200) {
						if (res.customData) {
							this.payVisible = true;
							this.wxpayUrl = false;
							this.alipayUrl = false;
							this.payUrl = false;
							this.payForm.type = 'wxpay'
							if (this.$refs.qrcode) {
								this.$refs.qrcode.innerHTML = '';
							}
						} else {
							this.getsipNumberData();
							this.$message.success(res.message);
						}
					} else {
						this.$message.error(res.message);
					}
				});
			},
			setAddVisible(row) {
				this.logVisible = true;
				this.sipNumbertableData2 = row.log;
			},
			typeChange(e) {
				this.$refs.qrcode.innerHTML = '';
				this.payForm.type = e;
				this.payUrl = false;
				clearInterval(this.clearInterval);
			},
			addRecordLabel() {
				this.$refs.qrcode.innerHTML = '';
				this.wxpayUrl = false;
				this.alipayUrl = false;
				let data = {
					ids: this.payForm.id,
					userId: localStorage.getItem('user'),
					type: this.payForm.type,
				}
				sipAccountOccupyOrder(data).then(res => {
					if (res?.code === 200) {
						this.payUrl = true;
						this.payData = res.data;
						if (this.payForm.type == 'wxpay') {
							this.wxpayUrl = true;
							this.qr = new QRCode('qrcode', {
								width: 130,
								height: 130, // 高度
								text: this.payData.url, // 二维码内容
								colorDark: '#000000',
								colorLight: '#ffffff'
							});
						} else if (this.payForm.type == 'alipay') {
							this.alipayUrl = true;
							this.qr = new QRCode('qrcode', {
								width: 130,
								height: 130, // 高度
								text: this.payData.qrCode, // 二维码内容
								colorDark: '#000000',
								colorLight: '#ffffff'
							});
						}
						this.clearInterval = setInterval(res => {
							let data = {
								out_trade_no: this.payData.out_trade_no
							};
							sipAccountOrderQuery(data).then(res => {
								if (res?.code === 200) {
									if (res.data == true) {
										this.$message.success('支付成功');
										this.$refs.qrcode.innerHTML = '';
										this.payUrl = false;
										this.$router.go(0);
										clearInterval(this.clearInterval);
									}
								} else {
									this.$message.error(res.message);
								}
							});
						}, 2000);
					} else {
						this.$message.error(res.message);
					}
				});
			},
			/* sipAccountPrice  里面的数据 */
			getsipAccountPriceData() {
				let data = {
					userId: localStorage.getItem('user'),
					agentId: this.query3.agentId,
					cardsId: this.query3.cardsId,
				};
				sipAccountPriceQuery(data).then(res => {
					if (res?.code === 200) {
						this.sipAccountPricetableData = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getsetPriceVisible() {
				this.setPriceForm.cardsId = '';
				this.setPriceForm.accountPrice = '';
				this.setPriceForm.agentId = '';
				this.setPriceVisible = true;
			},
			getsetSipAccountPrice() {
				let data = {
					userId: localStorage.getItem('user'),
					cardsId: this.setPriceForm.cardsId,
					accountPrice: this.setPriceForm.accountPrice,
					agentId: this.setPriceForm.agentId,
				};
				setSipAccountPrice(data).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.message);
						this.setPriceVisible = false;
						this.getsipAccountPriceData()
					} else {
						this.$message.error(res.message);
					}
				});
			},
			showEdit(row) {
				this.editForm = row;
				this.editVisible = true;
			},
			getsipAccountPriceUpdate() {
				let data = {
					userId: localStorage.getItem('user'),
					id: this.editForm.id,
					accountPrice: this.editForm.price,
				};
				sipAccountPriceUpdate(data).then(res => {
					if (res?.code === 200) {
						this.editVisible = false;
						this.getsipAccountPriceData()
					} else {
						this.$message.error(res.message);
					}
				});
			},
			closeEditDialog() {
				this.editVisible = false;
				this.getsipAccountPriceData()
			},


		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.down {
		border: 1px solid #dcdfe6;
		background: #4f7afd;
		color: #ffffff;
		transition: 0.1s;
		font-weight: 500;
		padding: 8px 16px;
		font-size: 12px;
		border-radius: 4px;
		margin-left: 10px;

		display: inline-block;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.table {
		width: 100%;
		font-size: 12px;
	}

	.red {
		color: #F56C6C;
	}

	.mr10 {
		margin-right: 10px;
	}

	.grid-con-icon {
		font-size: 50px;
		width: 100px;
		height: 100px;
		text-align: center;
		line-height: 100px;
		color: #fff;
	}

	.grid-cont-right {
		flex: 1;
		text-align: center;
		font-size: 20px;
		font-weight: bold;
		color: #999;
	}

	.grid-content {
		display: flex;
		align-items: center;
		height: 100px;
	}
</style>
<style>
	.import-visible .el-upload {
		width: 100% !important;
		display: flex !important;
		flex-direction: column !important;
		align-items: center !important;
		justify-content: center !important;
	}
</style>